import React from 'react'
import {
  TextField
} from '@material-ui/core';

const Explanation = ({explanation, handleChange}) => {
  return (
    <TextField  label="Explicación del caso"
      variant="outlined"
      name={'explanation'}
      multiline
      fullWidth
      margin={'normal'}
      value={explanation || ''}
      onChange={({target}) => handleChange(target)}
      type="text" />
  )
}

export default Explanation
